import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "@/lib/api";
import { fmtPrice } from "./priceUtils";

function Margin({ m, low, testid }) {
  if (!m) return <span className="text-slate-300">—</span>;
  const bad = m.pct < low;
  return (
    <span className={bad ? "font-semibold text-red-600" : "text-emerald-700"} data-testid={testid}>
      {fmtPrice(m.amount)} <span className="text-[11px]">({m.pct}%)</span></span>
  );
}

/** Reseller vs MSRP and Service Provider vs MSRP, $ and %; below the threshold is red. */
export function MarginsTab() {
  const [d, setD] = useState(null);
  useEffect(() => {
    api.get("/price-list/margins").then(({ data }) => setD(data))
      .catch((e) => toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Could not load margins"));
  }, []);
  if (!d) return <Loader2 className="mx-auto my-8 h-5 w-5 animate-spin text-slate-300" />;
  const lowCount = d.items.filter((i) => i.low).length;
  return (
    <div className="space-y-2" data-testid="price-margins">
      <div className="flex flex-wrap items-center gap-2 text-xs text-slate-600">
        <span data-testid="price-margins-low-count"><b className="text-red-600">{lowCount}</b> item(s) below {d.min_margin_pct}% margin</span>
      </div>
      <div className="max-h-[55vh] overflow-auto rounded-md border border-slate-200">
        <table className="w-full text-xs" data-testid="price-margins-table">
          <thead className="sticky top-0 bg-slate-50 text-[10px] uppercase tracking-wider text-slate-500">
            <tr><th className="px-2 py-2 text-left">Item</th><th className="px-2 text-right">MSRP</th><th className="px-2 text-right">Reseller</th>
              <th className="px-2 text-right">Reseller margin</th><th className="px-2 text-right">Service Provider</th><th className="px-2 text-right">SP margin</th></tr>
          </thead>
          <tbody>
            {d.items.map((i) => (
              <tr key={i.item_id} className={`border-t border-slate-100 ${i.low ? "bg-red-50/40" : ""}`} data-testid={`price-margin-row-${i.item_id}`}>
                <td className="px-2 py-1.5">{i.name}<div className="text-[10px] text-slate-400">{i.category}{i.status === "draft" ? " · draft" : ""}</div></td>
                <td className="px-2 text-right tabular-nums">{i.msrp == null ? "—" : fmtPrice(i.msrp)}</td>
                <td className="px-2 text-right tabular-nums">{i.reseller == null ? "—" : fmtPrice(i.reseller)}</td>
                <td className="px-2 text-right tabular-nums"><Margin m={i.reseller_margin} low={d.min_margin_pct} testid={`price-margin-reseller-${i.item_id}`} /></td>
                <td className="px-2 text-right tabular-nums">{i.sp == null ? "—" : fmtPrice(i.sp)}</td>
                <td className="px-2 text-right tabular-nums"><Margin m={i.sp_margin} low={d.min_margin_pct} testid={`price-margin-sp-${i.item_id}`} /></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
